export const usersState = state => state.users;

export const getLoadingUsers = state => usersState(state).loading;

export const getResponseUsers = (state) => usersState(state).response;
